// extracted by mini-css-extract-plugin
export default {"passwordPage":"change-password-page_passwordPage__Gw44V","passwordPanel":"change-password-page_passwordPanel__Qn71y","passwordForm":"change-password-page_passwordForm__O4+85"};